import { FC, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import AppSpinner from '../../../common/components/AppSpinner';
import { dispatchIdpCallbackEvent } from '../../actions/app-general-actions';

const ConfigureIDPPage: FC = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    dispatchIdpCallbackEvent(searchParams);
  }, [searchParams]);

  return <AppSpinner />;
};

export default ConfigureIDPPage;
